import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationAdditionalChargeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/AdditionalCharge/AdditionalChargeBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationAdditionalCharge"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationAdditionalCharge"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationAdditionalChargeActivity)
